var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap--sub"
  }, [_c('sub-visual', {
    class: _vm.typeClass,
    attrs: {
      "visual": _vm.typeName
    }
  }), _c('div', {
    staticClass: "contents"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm.isAuthorized ? [_c('div', {
    staticClass: "mb-15"
  }, [_c('h3', {
    staticClass: "text-28 text-md-20"
  }, [_vm._v(_vm._s(_vm.typeName) + " 신청")])]), _c('div', {
    staticClass: "row-v-table"
  }, [_c('write-area', {
    model: {
      value: _vm.request._area,
      callback: function callback($$v) {
        _vm.$set(_vm.request, "_area", $$v);
      },
      expression: "request._area"
    }
  }), _vm.isLong ? _c('write-duration', {
    model: {
      value: _vm.request,
      callback: function callback($$v) {
        _vm.request = $$v;
      },
      expression: "request"
    }
  }) : _vm._e(), _c('counsel-card-row', {
    attrs: {
      "label": "제목"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.request.title,
      callback: function callback($$v) {
        _vm.$set(_vm.request, "title", $$v);
      },
      expression: "request.title"
    }
  })], 1), _c('counsel-card-row', {
    attrs: {
      "label": "상세내용"
    }
  }, [_c('v-textarea', {
    model: {
      value: _vm.request.content,
      callback: function callback($$v) {
        _vm.$set(_vm.request, "content", $$v);
      },
      expression: "request.content"
    }
  })], 1), _c('write-files', {
    model: {
      value: _vm.request.files,
      callback: function callback($$v) {
        _vm.$set(_vm.request, "files", $$v);
      },
      expression: "request.files"
    }
  })], 1), _c('div', {
    staticClass: "board-buttons board-buttons--right-center"
  }, [_c('div', {
    staticClass: "left"
  }), _c('div', {
    staticClass: "right"
  }, [_c('v-btn', {
    attrs: {
      "outlined": "",
      "color": "gray-9"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_vm._v("취소")]), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("신청")])], 1)])] : [_c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v(" 권한이 없습니다. ")])], 1)]], 2)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }